import React, {useEffect, useRef, useState} from 'react';
import styles from './SearchField.module.css';

interface SearchFieldProps {
    value?: string;
    placeholder?: string;
    onChange: (newValue: string) => void;
    debounceTime?: number;
    width?: number;
}

export const SearchField: React.FC<SearchFieldProps> = ({value, placeholder, onChange, debounceTime = 500}) => {

    const [internalValue, setInternalValue] = useState(value || '');
    const debounceRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        setInternalValue(value || '');
    }, [value]);

    const handleChange = (val: string) => {
        setInternalValue(val);

        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        debounceRef.current = setTimeout(() => {
            onChange(val);
        }, debounceTime);
    };

    return (
        <div className={styles.container}>
            <div className={styles.icon}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M18.9996 11.4997C18.9994 7.35775 15.6416 3.99971 11.4996 3.99971C7.35776 3.99992 3.9998 7.35788 3.99958 11.4997C3.99958 15.6417 7.35763 18.9995 11.4996 18.9997C13.5185 18.9997 15.3497 18.2006 16.698 16.9032C16.7266 16.8649 16.7581 16.8279 16.7929 16.7931C16.8278 16.7582 16.8648 16.7268 16.9031 16.6981C18.2005 15.3499 18.9996 13.5186 18.9996 11.4997ZM21 11.4997C21 13.7627 20.2069 15.8398 18.8859 17.4716L21.7066 20.2935L21.7758 20.3685C22.0963 20.7612 22.0728 21.3405 21.7066 21.7067C21.3404 22.0729 20.7611 22.0965 20.3683 21.7759L20.2933 21.7067L17.4715 18.886C15.8397 20.207 13.7626 21.0001 11.4996 21.0001C6.25306 20.9999 2.00037 16.7463 2.00037 11.4997C2.00058 6.25331 6.25319 2.0007 11.4996 2.00049C16.7462 2.00049 20.9998 6.25318 21 11.4997Z"
                        fill="#01080F"/>
                </svg>
            </div>
            <input
                className={styles.input}
                placeholder={placeholder || 'Search'}
                value={internalValue}
                onChange={e => handleChange(e.target.value)}
            />
        </div>
    );
};
